(function (ss) {
  var utils = ss.utils,
      sizes = {
        tiny: 'tiny',
        small: 'small',
        medium: 'medium',
        large: 'large',
        xlarge: 'xlarge',
        full: 'full'
      },
      grid = {
        singleColumn: 'small-block-grid-1 medium-block-grid-1 large-block-grid-1',
        multiColumns: 'small-block-grid-1 medium-block-grid-2 large-block-grid-3'
      },
      selectors = {
        template: '#top-clipboards-thumbnail-template',
        lazyImg: '.thumbnail .link-bg-img'
      },
      templates  = {
        thumbnail: utils.imports('templates.clipping.top-clipboards-thumbnail')
      };

  function TopClipboardsModal(options) {
    this.$el = $(options.el);
    this.$loader = this.$el.find('.loading');
    this.$empty = this.$el.find('.empty');
    this.$clipboards = this.$el.find('.clipboards');
    this.$clipboardsList = this.$clipboards.find('ul');

    // TODO: declare at the top after moving js packaging to gulp
    //       until then it should stay here to avoid errors due to load order
    this.api = utils.imports('clips.api');
  }

  /**
   * Loads the top clipboards from the server
   * @param {Function} cb The callback that will be called when the clipboards are available
   */
  TopClipboardsModal.prototype.loadClipboards = function(cb) {
    this.api.topClipboards(this.slideshowId, this.position)
      .then(function(clipboards) {
        cb(clipboards);
      }.bind(this), function() {
        console.log('failed to load clipboards', arguments);
        cb([]);
      });
  };

  /**
   * Displays a list of clipboards
   * @param {Array} clipboards The list of clipboards
   */
  TopClipboardsModal.prototype.showClipboards = function(clipboards) {
    this.$clipboardsList.empty().append(clipboards.map(templates.thumbnail));
    this.$clipboards.show();
    this.$el.find(selectors.lazyImg).lazyload({threshold: 300, effect: 'fadeIn'});
  };

  /**
   * Hides the clipboards list
   */
  TopClipboardsModal.prototype.hideClipboards = function(data) {
    this.$clipboards.hide();
  };

  /**
   * Shows a message when there are no clipboards to display
   */
  TopClipboardsModal.prototype.showEmptyMessage = function() {
    this.$empty.show();
  };

  /**
   * Hides the empty clipboards list message
   */
  TopClipboardsModal.prototype.hideEmptyMessage = function() {
    this.$empty.hide();
  };

  /**
   * Updates the modal size according to the number of clipboards to be displayed
   */
  TopClipboardsModal.prototype.updateModalSize = function(clipboards) {
    var isSmall = clipboards.length <= 2;

    this.$el
      .removeClass(sizes.medium)
      .removeClass(sizes.xlarge)
      .addClass(isSmall ? sizes.medium : sizes.xlarge);
    this.$clipboardsList
      .removeClass()
      .addClass(isSmall ? grid.singleColumn : grid.multiColumns);
  };

  /**
   * Opens the modal dialog and loads it with the top clipboards for a slideshow slide.
   * @param {Number} slideshowId The slideshow id
   * @param {Number} position The slide position
   */
  TopClipboardsModal.prototype.open = function(slideshowId, position) {
    this.slideshowId = slideshowId;
    this.position = position;

    this.showLoader();
    this.hideEmptyMessage();
    this.hideClipboards();
    this.$el.foundation('reveal', 'open');

    this.loadClipboards(function(data) {
      this.hideLoader();
      if(!data || data.length === 0) {
        this.showEmptyMessage();
      } else {
        this.updateModalSize(data);
        this.showClipboards(data);
      }
    }.bind(this));
  };

  /**
   * Closes the modal dialog
   */
  TopClipboardsModal.prototype.close = function() {
    this.$el.foundation('reveal', 'close');
  };

  /**
   * Shows the loader
   */
  TopClipboardsModal.prototype.showLoader = function() {
    this.$loader.show();
  };

  /**
   * Hides the loader
   */
  TopClipboardsModal.prototype.hideLoader = function() {
    this.$loader.hide();
  };

  utils.exports('clips.TopClipboardsModal', TopClipboardsModal);
}(window.slideshare_object));